// Persists the collapsed/expanded state of the Edit Validation Record page's two drawers
// (left = progress menu, right = comments & alerts) in localStorage, so the user's preference
// survives navigation and reloads. Global per user (not per record) — matches verificationRoleCache.
const LEFT_KEY = 'sv_edit_record_left_drawer_collapsed';
const RIGHT_KEY = 'sv_edit_record_right_drawer_collapsed';

function readCollapsed(key: string): boolean {
  try {
    return localStorage.getItem(key) === 'true';
  } catch {
    return false;
  }
}

function writeCollapsed(key: string, collapsed: boolean): void {
  try {
    localStorage.setItem(key, String(collapsed));
  } catch {
    // Ignore write failures (e.g. storage disabled / quota) — the toggle still works for the session.
  }
}

export function readLeftDrawerCollapsed(): boolean {
  return readCollapsed(LEFT_KEY);
}

export function writeLeftDrawerCollapsed(collapsed: boolean): void {
  writeCollapsed(LEFT_KEY, collapsed);
}

export function readRightDrawerCollapsed(): boolean {
  return readCollapsed(RIGHT_KEY);
}

export function writeRightDrawerCollapsed(collapsed: boolean): void {
  writeCollapsed(RIGHT_KEY, collapsed);
}
